<template>
    <div class="codics-aonaer-info-sys-news-info-body">
        <WebHeader></WebHeader>
        <div class="codics-aonaer-info-sys-news-info-box">
            <div class="codics-aonaer-info-sys-news-info-container" ref="lastNewsContainer">
                <div class="codics-aonaer-info-sys-news-info-nr">
                    <div class="codics-aonaer-info-sys-news-info-title">{{ xwData?.title }}</div>
                    <div class="codics-aonaer-info-sys-news-info-info">
                        作者：{{ xwData?.account?.nickname }}&nbsp;&nbsp;&nbsp;&nbsp;时间：{{ initTime(xwData.stime)
                        }}&nbsp;&nbsp;&nbsp;&nbsp;浏览：{{
                        xwData.see }}
                    </div>
                    <div class="codics-aonaer-info-sys-news-info-content" v-html="xwData.content"></div>
                    <div class="codics-aonaer-info-sys-news-info-nlbox">
                        上一篇：<a @click="jumpToPage(beforeData.length == 0 ? '没有了' : beforeData[0]?.id)">{{
                        beforeData.length == 0 ? '没有了'
                            : beforeData[0]?.title }}</a><br>
                        下一篇：<a @click="jumpToPage(afterData.length == 0 ? '没有了' : afterData[0]?.id)">{{
                        afterData.length == 0 ? '没有了' : afterData[0]?.title }}</a>
                    </div>
                </div>
                <div class="codics-aonaer-info-sys-news-info-last-news" ref="lastNewsBox" :style="ccCss">
                    <div class="codics-aonaer-info-sys-news-info-last-news-tip" style="">热门资讯</div>
                    <div class="codics-aonaer-info-sys-news-info-last-news-item" @click="jumpToPage(item?.id)"
                        v-for="(item, index) in [...beforeData, ...afterData]"
                        :style="{ borderBottom: index == [...beforeData, ...afterData].length - 1 ? 'unset' : '1px solid #ddd' }"
                        :key="index">
                        <el-image class="codics-aonaer-info-sys-news-info-last-news-item-img"
                            :src="'https://cdn.bosscaigou.com/' + item?.himg" fit="cover"></el-image>
                        <div class="codics-aonaer-info-sys-news-info-last-news-item-other">
                            <div class="codics-aonaer-info-sys-news-info-last-news-item-title">{{ item?.title }}</div>
                            <div class="codics-aonaer-info-sys-news-info-last-news-item-stime">{{ item?.stime }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import { infoNews } from '@/api';
import dayjs from 'dayjs';
import { jumpTo } from '@/utils/myutils';
export default {
    data() {
        return {
            xwCount: 0,
            beforeData: [],
            xwData: {
                title: '',
                author: '',
                stime: new Date(),
                see: 0,
                content: ``
            },
            afterData: [],
            ccCss: '',
            newsData: []
        }
    },
    mounted() {

        this.infoNewsFUc();

        window.addEventListener('scroll', this.handleScroll);


    },


    beforeDestroy() {


        window.removeEventListener('scroll', this.handleScroll);


    },
    methods: {
        jumpToPage(n) {
            if (n == '没有了') return;
            window.location = window.location.origin + '/news_info/' + n;
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        async infoNewsFUc() {

            let data = await infoNews({ id: this.$route.params.id });

            if (data.code == 200) {

                this.xwData = data.data;

                this.beforeData = data.data1;

                this.afterData = data.data2;

            } else {

                this.$message.error(data.message);

            }

        },
        handleScroll() {

            const height = this.$refs.lastNewsContainer.offsetHeight;

            const height2 = this.$refs.lastNewsBox.offsetHeight;

            const scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop < 30) {

                this.ccCss = '';

            } else if (scrollTop >= 30 && height - scrollTop + 30 >= height2) {

                this.ccCss = `position: fixed !important;top: ${scrollTop - 30}px;right:0;`;

            } else {

                this.ccCss = `position: absolute !important;bottom: 0px;right:0;`;

            }

        }
    },
    components: {
        WebHeader,
        WebFooter
    }
}
</script>

<style>
.codics-aonaer-info-sys-news-info-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #f7f7f7;
}

.codics-aonaer-info-sys-news-info-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 60px 0;
}

.codics-aonaer-info-sys-news-info-container {
    height: fit-content;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
}

.codics-aonaer-info-sys-news-info-nr {
    height: fit-content;
    width: calc(100% - 390px);
    min-height: 555px;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 30px;
}

.codics-aonaer-info-sys-news-info-title {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    font-size: 28px;
    line-height: 36px;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-bottom: 20px;
}

.codics-aonaer-info-sys-news-info-info {
    height: 26px;
    width: 100%;
    position: relative;
    float: left;
    padding-bottom: 30px;
    margin-bottom: 45px;
    border-bottom: 1px solid #eee;
    text-align: center;
    line-height: 26px;
    font-size: 16px;
}

.codics-aonaer-info-sys-news-info-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    font-size: 16px;
    line-height: 28px;
}

.codics-aonaer-info-sys-news-info-content img {
    height: fit-content;
    width: 100%;
    object-fit: contain;
}

.codics-aonaer-info-sys-news-info-nlbox {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    margin-top: 40px;
    box-sizing: border-box;
    padding-top: 32px;
    border-top: 1px solid #eee;
    line-height: 32px;
    font-size: 15px;
    color: #999;
}

.codics-aonaer-info-sys-news-info-nlbox a {
    height: 100%;
    width: calc(100% - 85px);
    color: #222;
    cursor: pointer;
    text-decoration: none;
    transition: .3s;
    max-width: calc(100% - 85px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
    line-height: 32px;
}

.codics-aonaer-info-sys-news-info-nlbox a:hover {
    color: #ea5b18;
}

.codics-aonaer-info-sys-news-info-last-news {
    height: fit-content;
    width: 360px;
    position: relative;
    float: left;
    margin-left: 30px;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
}

.codics-aonaer-info-sys-news-info-last-news-tip {
    font-size: 22px;
    font-weight: bold;
    line-height: 30px;
    color: #000;
    margin-bottom: 20px;
}

.codics-aonaer-info-sys-news-info-last-news-item {
    height: 115px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px 0;
    cursor: pointer;
}

.codics-aonaer-info-sys-news-info-last-news-item-img {
    height: 100%;
    width: 118px;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-news-info-last-news-item-other {
    height: 100%;
    width: calc(100% - 118px);
    position: relative;
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
}

.codics-aonaer-info-sys-news-info-last-news-item-title {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    line-height: 22px;
    font-size: 16px;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    transition: .3s;
}

.codics-aonaer-info-sys-news-info-last-news-item:hover .codics-aonaer-info-sys-news-info-last-news-item-title {
    color: #ea5b18;
}

.codics-aonaer-info-sys-news-info-last-news-item img {
    transition: .3s;
}

.codics-aonaer-info-sys-news-info-last-news-item:hover img {
    transform: scale(1.1);
}

.codics-aonaer-info-sys-news-info-last-news-item-stime {
    position: relative;
    float: left;
    font-size: 14px;
    color: #999;
    line-height: 16px;
    margin-top: 15px;
    display: block;
}
</style>